import React,{useState,useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faClock,faClone,faMoneyBill, faMoneyBillAlt} from '@fortawesome/free-solid-svg-icons';

const FeeStructure = (props) => {
  const detail=props.detail
  const profileDetail = props.profileDetail;
  // const payType=props.payType
  // const fee=payType !==undefined &&payType.value==1?detail.installment_amount:detail.lumpsum_amount
  const[payType,setPayType]=useState()
   const fee=payType !==undefined &&payType.value==1?(detail.installment_amount_local?detail.installment_amount_local:detail.installment_amount):(detail.lumpsum_amount_local ?detail.lumpsum_amount_local:detail.lumpsum_amount)
  const vat=detail.vat?detail.vat:0
  const feePaymentDetail = profileDetail?.feeDetail

  
  useEffect(() => {
    const detail=props.detail
    const payType=props.payType
    if(payType!==undefined){
      setPayType(payType)
    }
},[props.detail,props.payType])
  return (
    <div className="col-lg-12 mt-5">
        <div className="course-features fee_features mt-30">
            <h6 className="fw-bold text-center mb-5">{profileDetail.course}
            </h6>

            {feePaymentDetail?.installments_number >= 1 ?
              <ul className='list-unstyled'>
                <li><FontAwesomeIcon icon={faMoneyBill}/>Net Payable Amount ({payType?.value==1?'Installment' : 'lumpsum'})  :  <span> {detail?.local_currency?detail?.local_currency:'AED'} {parseFloat(fee).toFixed(2)}</span></li>                   
              </ul> 
            :
            <ul className='list-unstyled'>
                 <li><FontAwesomeIcon icon={faMoneyBillAlt}/> Total Course Fee: <span>{detail?.local_currency?detail?.local_currency:'AED'} {parseFloat(detail?.total_fee_local?detail?.total_fee_local: detail?.total_fee).toFixed(2)}</span></li>
                <li><FontAwesomeIcon icon={faMoneyBillAlt}/> Scholarship Amount ({parseFloat(detail?.scholarship_percentage).toFixed(2)}%): <span> - {detail?.local_currency?detail?.local_currency:'AED'} {parseFloat(detail?.scholarship_amount_local? detail?.scholarship_amount_local:detail?.scholarship_amount).toFixed(2)}</span></li>
                <li><FontAwesomeIcon icon={faMoneyBill}/>Net Payable Amount ({payType?.value==1?'Installment' : 'lumpsum'})  :  <span> {detail?.local_currency?detail?.local_currency:'AED'} {parseFloat(fee).toFixed(2)}</span></li>                   
            </ul>  
          
          }
            
        </div> 
    </div>
  )
}

export default FeeStructure
